import { render } from "./ExceptionBoard.vue?vue&type=template&id=16ca6627"
import script from "./ExceptionBoard.vue?vue&type=script&lang=js"
export * from "./ExceptionBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/.pnpm/@vue+cli-service@5.0.9_@vue+compiler-sfc@3.5.26_lodash@4.17.21_sass-loader@13.3.3_node-_2efde1b6c902023e3f10239734cd10e2/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__